/**
 * 진입 코드 정규화/검증 순수 함수.
 *
 * 입력은 두 형태를 모두 허용한다:
 *  1) QR 스캔 결과 URL (예: 'https://quiz.zep.us/code-login?code=A2B3C4D')
 *  2) 사용자가 직접 입력/스캔한 raw 코드 (예: 'a2b3c4d')
 *
 * 처리 순서:
 *  - 'code=' 가 포함되면 URL searchParams 의 `code` 값을 추출, 아니면 입력 그대로 사용
 *  - 대문자화 후 [A-Z0-9] 외 문자 제거
 *  - 혼동되는 문자(I, L, O, 0, 1)를 배제한 7자리 코드 정규식에 일치하면 반환, 아니면 null
 *
 * 혼동 문자 배제 집합은 BE UserCodeGenerator 의 알파벳과 정합한다.
 * U prefix + 혼동문자(I,L,O,0,1) 배제 알파벳 7자 = 총 8자 (BE UserCodeGenerator U-prefix 8자 정합).
 */
const VALID_CODE_PATTERN = /^U[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{7}$/;

function extractRawCode(input: string): string {
  if (input.includes('code=')) {
    try {
      // 상대/절대 URL 모두 파싱 가능하도록 base 를 제공한다.
      const url = new URL(input, 'https://placeholder.invalid');
      return url.searchParams.get('code') ?? '';
    } catch {
      return '';
    }
  }
  return input;
}

export function parseScannedCode(input: string): string | null {
  const raw = extractRawCode(input);
  const normalized = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');

  return VALID_CODE_PATTERN.test(normalized) ? normalized : null;
}
